// extracted by mini-css-extract-plugin
export default {"dropzone":"Uploader_dropzone__IZYUX","active":"Uploader_active__4vdpr"};